/**
 * GoogleAnalyticsModel.js
 * Created on 20-apr-2016
 * 
 * 
 * @author Reinier Feijen for Ranj
 **/
export default class GoogleAnalyticsModel {
    //store any GA data here
}